import { getLoggerWithVerbosity, getVerbosity } from './verbosity'

const verbosity = getVerbosity(process.env.NODE_ENV as string)
export const Logger = getLoggerWithVerbosity(verbosity)
